export default "/_next/static/src/lib/assets/rive/e768f6e916f0e5fffaeeeedc32c0e2ac.riv";